import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ChatMessage, DataOrigin } from '@iese-chatbot/common-utils';
import { FilesUiComponent, NoneUiComponent, RepositoryUiComponent } from '@iese-chatbot/ui-design-system';

@Component({
  selector: 'icbc-chat-message-icon',
  standalone: true,
  imports: [CommonModule, NoneUiComponent, FilesUiComponent, RepositoryUiComponent],
  templateUrl: './chat-message-icon.component.html',
})
export class ChatMessageIconComponent implements OnChanges {
  @Input() public message!: ChatMessage;
  protected icon: DataOrigin = DataOrigin.REPOSITORY;

  ngOnChanges(changes: SimpleChanges): void {
    const message = changes['message'].currentValue as ChatMessage;
    this.icon = message.dataOrigin ?? (message.fromIESEKnowledge ? DataOrigin.REPOSITORY : DataOrigin.NONE);
  }

  protected readonly DataOrigin = DataOrigin;
}
